export default "__VITE_ASSET__BDXGpQMo__"